module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-centered"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered",
    attrs: {
      "id": "forgotPasswordFormContainer"
    }
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/eurotrader_logo_rgb_purple.svg")
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "is-title is-bold"
  }, [_vm._v(_vm._s(_vm.$t("reset_account_password").tUpper()))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "red",
      "word-wrap": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (_vm.validCode == true) ? _c('form', {
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updatePassword($event)
      }
    }
  }, [_c('label', {
    staticClass: "label",
    class: {
      'float-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t("new_password").tUpper()))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.password),
      expression: "data.body.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|strong-password|confirmed:confirm_password'),
      expression: "'required|strong-password|confirmed:confirm_password'"
    }],
    staticClass: "input",
    attrs: {
      "name": "password",
      "id": "password",
      "type": "password",
      "maxlength": "20",
      "placeholder": "(new password)"
    },
    domProps: {
      "value": (_vm.data.body.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label",
    class: {
      'float-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t("confirm_new_password").tUpper()))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.body.passwordConfirm),
      expression: "data.body.passwordConfirm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input",
    attrs: {
      "name": "confirm_password",
      "id": "confirm_password",
      "type": "password",
      "maxlength": "20",
      "placeholder": "(retype password)"
    },
    domProps: {
      "value": (_vm.data.body.passwordConfirm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data.body, "passwordConfirm", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary login",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("submit").tUpper()))])]), _vm._v(" "), _c('div', {
    staticClass: "is-center bottom_options_box"
  }, [_c('span', {
    staticClass: "select is-small lang"
  }, [_c('language')], 1), _vm._v(" "), _c('a', {
    staticClass: "is-small",
    attrs: {
      "href": "https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Risk%20Disclosure.pdf",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("risk_disclosure").tTitle()))])]), _vm._v(" "), _c('div', {
    staticClass: "is-clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.validCode == false) ? _c('div', {
    staticClass: "invalidRequestMsgDiv"
  }, [_vm._v(_vm._s(_vm.$t("error_expired_or_invalid_request").tUpper()))]) : _vm._e()])])]), _vm._v(" "), _c('error-modal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c6e4ab0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/ResetPassword.vue
// module id = 752
// module chunks = 0